import { render, staticRenderFns } from "./AllExams.vue?vue&type=template&id=206237d2"
import script from "./AllExams.vue?vue&type=script&lang=js"
export * from "./AllExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports